import React, { Fragment, useEffect } from 'react';
import { Col, Card, CardHeader, CardFooter, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { H6, H5, P, Btn, Spinner } from 'AbstractElements';
import TestimonyProgramListDetail from '../TestimonyProgramListDetail';
import ModalAssets from '../ModalAssets';
import Moment from 'moment';
import 'moment/locale/id';
import ModalProgram from '../ModalProgram';

const TestimonyProgramContain = ({ setRefetch }) => {
  const dispatch = useDispatch();
  const detail = useSelector(state => state.testimonyProgram.detail);
  const isLoading = useSelector(state => state.testimonyProgram.isLoading);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <Fragment>
      {
        isLoading &&
        <Col lg="12">
          <div className="loader-box">
            <Spinner attrSpinner={{ className: 'loader-30' }} />
          </div>
          <H6 attrH6={{ className: 'sub-title mb-3 text-center' }}>{'Data Loading...'}</H6>
        </Col>
      }
      <Row>
        <Col sm="12" xl="12" lg="12" className="xl-100 box-col-12 order-1">
          <Card className="social-widget-card">
            <CardHeader>
              <Col>
                <Row>
                  <Col>
                    <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{detail?.name || 'Nama Group Testimoni'}</H5>
                  </Col>
                </Row>
              </Col>
            </CardHeader>
            <CardFooter>
              <Row style={{ alignItems: 'center' }}>
                <Col>
                  <P attrP={{ className: 'font-roboto' }}>Created at: {Moment(detail?.created_at).format('dddd, D MMMM YYYY')} - {Moment(detail?.created_at).format('HH:mm:ss')} WIB</P>
                  <P attrP={{ className: 'font-roboto' }}><b>Updated at: {Moment(detail?.updated_at).format('dddd, D MMMM YYYY')} - {Moment(detail?.updated_at).format('HH:mm:ss')} WIB</b></P>
                </Col>
                <Col className='text-end d-flex' style={{ justifyContent: 'flex-end', gap: '5px' }}>
                  <Link to={`${process.env.PUBLIC_URL}/testimony-program`}>
                    <Btn attrBtn={{ color: 'warning', className: 'btn btn-primary' }}>
                      <i className="fa fa-chevron-circle-left fa-lg me-2"></i>Back
                    </Btn>
                  </Link>
                  <ModalAssets id={detail?.id} />
                  <ModalProgram id={detail?.id} mainPrograms={detail?.mainPrograms} />
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <TestimonyProgramListDetail
            title="Gambar"
            items={detail.staticAssets}
            dispatch={dispatch}
            setRefetch={setRefetch}
          />
        </Col>
        <Col>
          <TestimonyProgramListDetail
            title="Program"
            items={detail.mainPrograms}
            dispatch={dispatch}
            setRefetch={setRefetch}
          />
        </Col>
      </Row>
    </Fragment>
  );
};
export default TestimonyProgramContain;